import React from "react";
import ReactDom from 'react-dom';
import './index.css';
import { BrowserRouter as Router } from "react-router-dom";
import { createStore } from "redux";
import { Provider } from "react-redux";
import App from './App'
import myReducers from "./context/reducers";

const myStore = createStore(myReducers,window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__());

ReactDom.render(
    <Router>
        <Provider store={myStore}>
            <App />
        </Provider>
    </Router>,
    document.getElementById('root')
)